import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import alert from './slice/alert';
import popPaper from './slice/popPaper';
import dgpaCalendar from './slice/dgpaCalendar';
import tour from './slice/tour';
import searchDraft from './slice/searchDraft';

import main from './slice/main';
import contact from './slice/contact';
import prefer from './slice/prefer';
import schedule from './slice/schedule';
import requirement from './slice/requirement';
import travelDetail from './slice/travelDetail';
import customRequest from './slice/customRequest';
import modifyTour from './slice/modifyTour';
import teach from './slice/teach';
import country from './slice/country';
import modifyTourExtra from './slice/modifyTourExtra';
import airport from './slice/airport';

export default configureStore({
  reducer: {
    alert: alert,
    popPaper: popPaper, // 浮動視窗
    dgpaCalendar: dgpaCalendar, // 日曆/行事曆/國定假日
    tour: tour,
    searchDraft: searchDraft,

    main: main, // 主要資訊
    contact: contact, // 聯絡資訊
    requirement: requirement, // 需求條件
    prefer: prefer, // 偏好設定
    schedule: schedule, // 行程規劃
    travelDetail: travelDetail, // 行程規劃
    customRequest: customRequest, // 查詢訂單
    modifyTour: modifyTour, // 調整行程
    teach: teach, // 調整行程教學
    country: country, // 國家選單
    modifyTourExtra: modifyTourExtra, // 調整行程2.0 - 擴充
    airport: airport, // 調整行程2.5 - 機場資訊
  },
  middleware: [logger],
});
